import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../app-settings';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SalesReportService {
  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  };

  constructor(private http: HttpClient) { }

  getSalesReportBySession(id: any, page: number = 1, channel?: any, type?: any, sortDate?: any, searchText?: any) {
    const id_business = localStorage.getItem('id_business') || '';
    let url = AppSettings.API_URI_V2 + `/company/${id_business}/session/${id}/sales/report?page=${page}`;
    const params: any[] = [];
    if (channel != '' && channel != 'all' && channel != undefined) {
      url += `&channel=${channel}`;
    }
    if (type != '' && type != 'all' && type != undefined) {
      url += `&type=${type}`;
    }
    if (sortDate != '' && sortDate != 'default' && sortDate != undefined) {
      url += `&date_order=${sortDate}`;
    }
    if (searchText != '' && searchText != undefined) {
      url += `&search=${searchText}`;
    }

    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getListsSessions(companyId: number, page: number = 1, itemsPerPage: number = 15, dateFrom?: string, dateTo?: string, sessionSearch?: string) {
    let url = AppSettings.API_URI_V2 + `/company/${companyId}/session/list?page=${page}&per_page=${itemsPerPage}`;
    if (dateFrom) { url += `&date_from=${dateFrom}`; }
    if (dateTo)   { url += `&date_to=${dateTo}`; }
    if (sessionSearch) { url += `&search=${encodeURIComponent(sessionSearch)}`; }
    return this.http.get<any>(url).pipe(map((data) => data));
  }

  getPrintUrlTicket(idOrder: number) {
    const url = `${AppSettings.API_URI_V2}/orders/${idOrder}/tickets-urls`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getPrintUrlTicketByTransaction(id_transaction: number) {
    const url = `${AppSettings.API_URI_V2}/tpv/transaction/${id_transaction}/tickets-urls`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  downloadReportSales(id) {
    const company = localStorage.getItem('id_business') || '';
    return this.http
      .get<any>(AppSettings.API_URI_V2 + `/company/${company}/cashregister/session/${id}/pdf`, {
        responseType: 'text' as 'json',
      })
      .pipe(
        map((data) => {
          const byteArray = new Uint8Array(
            atob(data)
              .split('')
              .map((char) => char.charCodeAt(0))
          );
          return new Blob([byteArray], { type: 'data:application/pdf' });
        })
      );
  }
}
